import { Storage } from '../utils/native_adapters'
import { useStorage } from './use_storage'

type SetValue<TCacheData> = (_itemValue?: TCacheData | null) => Promise<void>

export function useAsyncStorage<TCacheData>(
  key: string,
  initialValue: TCacheData,
  throwOnError: boolean = false
): [TCacheData, SetValue<TCacheData>] {
  return useStorage<TCacheData>(Storage, key, initialValue, throwOnError)
}
